var _path, _path2, _polygon, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8MarshallIslandsCircular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#283593",
    d: "M7.006,34.525L7.006,34.525C10.534,40.205,16.811,44,23.989,44c11.046,0,20-8.954,20-20 c0-0.932-0.086-1.842-0.209-2.74L7.006,34.525z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#283593",
    d: "M39.522,11.412C35.855,6.893,30.262,4,23.989,4c-11.046,0-20,8.954-20,20 c0,2.63,0.521,5.134,1.443,7.434L39.522,11.412z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#eceff1",
    points: "23.553,14.964 23.498,14.96 23.553,14.956 23.443,14.956 18.846,14.632 21.512,13.635 18.614,14.075 20.91,12.406 18.313,13.589 20.145,11.34 17.942,13.125 19.078,10.551 17.385,12.847 17.826,10.018 16.806,12.661 16.507,7.932 16.507,7.931 16.211,12.661 15.191,10.018 15.631,12.847 13.939,10.551 15.075,13.125 12.872,11.34 14.704,13.589 12.107,12.406 14.402,14.075 11.504,13.635 14.17,14.632 9.573,14.956 9.464,14.956 9.519,14.96 9.464,14.964 9.573,14.964 14.17,15.289 11.504,16.286 14.402,15.845 12.107,17.515 14.704,16.332 12.872,18.581 15.075,16.796 13.939,19.369 15.631,17.074 15.191,19.903 16.211,17.26 16.509,21.988 16.509,21.989 16.806,17.26 17.826,19.903 17.385,17.074 19.078,19.369 17.942,16.796 20.145,18.581 18.313,16.332 20.91,17.515 18.614,15.845 21.512,16.286 18.846,15.289 23.443,14.964"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M43.779,21.256l-0.098-0.646c-0.283-1.655-0.762-3.241-1.425-4.731L6.093,32.89 c0.279,0.561,0.584,1.106,0.913,1.635L43.779,21.256z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#f57c00",
    d: "M42.257,15.882c-0.718-1.613-1.636-3.116-2.735-4.47L5.436,31.442 c0.209,0.52,0.444,1.025,0.694,1.523L42.257,15.882z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8MarshallIslandsCircular);
export default __webpack_public_path__ + "static/media/icons8-marshall-islands-circular.9a9c7e9090b1d7becbe789e37c4f9302.svg";
export { ForwardRef as ReactComponent };